// The native one doesn't execute the task when the event loop stack is empty, the promise variation does.
export function bpQueueMicrotask(callback: () => void): void {
	void Promise
		.resolve()
		.then(callback);
}
